import { useContext, useState } from "react";
import * as yup from "yup";
import accoutsService from "services/accouts";
import Context from "context/UserContext";
import useUser from "./useUser";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Swal from "sweetalert2";
import { subYears, format } from "date-fns";

const today = new Date();
const minDate = subYears(today, 100);
const maxDate = subYears(today, 18);

const schema = yup.object().shape({
  cumpleanos: yup.date()
  .required("El campo es obligatorio")
  .min(minDate, `La fecha debe ser posterior al ${format(minDate, 'dd/MM/yyyy')}`)
  .max(maxDate, `Debes ser mayor de 18 años. La fecha debe ser anterior al ${format(maxDate, 'dd/MM/yyyy')}`),
  escolaridad: yup.string().required("El campo es obligatorio"),
  

});

export default function useEscolaridad() {
  const {
    control,
    register,
    reset,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const { token } = useContext(Context);
  const { tokenFull, IdUser, Roles } = useUser();
  const closeModal = () =>{
    console.log('cerrar');
    Swal.fire({
      title: 'Información',
      text: 'Favor de llenar los campos.',
      icon: 'info',
      timer: 4000,
      timerProgressBar: true,
      confirmButtonColor: '#ed7100',
    });
   // setIsOpen(false);
  }
    

  const get_escolaridad = async () => {
    /*     accoutsService.getEscolaridad(token,IdUser).then(({ data }) => {
      console.log(data);
    }); */

    const { data } = await accoutsService.accout(token, IdUser);
    return data;
  };

  const onSubmit = (values) => {
    const { cumpleanos } = values;
    const fecha = new Date(cumpleanos);
    const dia = fecha.getDate().toString().padStart(2, "0");
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
    const anio = fecha.getFullYear();
    const birthdate = `${anio}-${mes}-${dia}`;
    const update_birthdate = 1;

    const data = { ...values, cumpleanos: birthdate, update_birthdate };
    setLoading(true);
    accoutsService
      .editUser(token, IdUser, data)
      .then((data) => {
        Swal.fire({
          title: "Gracias por ingresar tus datos",
          text: "Los datos se han actualizado correctamente.",
          icon: "success",
          confirmButtonColor: "#ed7100",
        });
        reset();
        setIsOpen(false);
      })
      .catch((err) => {
        alert("Error al actualizar los datos");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    isOpen,
    openModal,
    closeModal,
    onSubmit,
    control,
    register,
    errors,
    handleSubmit,
    loading,
    get_escolaridad,
    minDate,
    maxDate,
  };
}
